// Centralized brand logo URL — new clean version (deep red bg, white & gold "scALe")
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_scale-talent-network/artifacts/olf8hf08_ChatGPT%20Image%20May%202%2C%202026%2C%2008_44_41%20PM.png";
